export const RANK_EMBLEM = {
  FIRST: 1,
  SECOND: 2,
  THIRD: 3,
};
